/* eslint-disable */
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Grid, Paper, Typography, Tooltip, IconButton, Button } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { getCobranza } from "../../../project/services/CobranzaService";
import Message from "../../../project/utils/Message";
import { isEmptyObject } from "../../../project/utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";
import Item from "../../utils/Item";
import { formatMoney } from "../../utils/utils";
//
// ################################################################################
//
const CobranzaVer = () => {
  const params = useParams();
  const idCobranza = params.idCobranza;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [cobranzaCabecera, setCobranzaCabecera] = useState({});
  const [cobranzaEstado, setCobranzaEstado] = useState([]);
  const [cobranzaGC, setCobranzaGC] = useState([]);
  const [cobranzaMDC, setCobranzaMDC] = useState([]);

  const tableGCColumns = [
    {
      field: "codigo_gc",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion_gc",
      headerName: "Fecha Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion_gc;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente +
          " " +
          params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "precio_venta_total_gc",
      headerName: "Total GC",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.precio_venta_total_gc;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "importe_recargo",
      headerName: "Total recargo",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe_recargo;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "importe_descuento",
      headerName: "Total descuento",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe_descuento;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "total_cobrado",
      headerName: "Total cobrado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = (
          params.row.importe_cobrado +
          params.row.importe_descuento +
          params.row.importe_recargo
        ).toFixed(2);
        return _val;
      },
    },
    {
      field: "particular_osocial_gc",
      headerName: "Particular/OS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.particular_osocial_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta_area",
      headerName: "Sucursal",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_usuario + " " + params.row.apellido_usuario;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Ver",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver gestión comercial">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => verGestionComercial(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const tableMDCColumns = [
    {
      field: "tipo_cobro",
      headerName: "Tipo de Cobro",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "";
        switch (params.row.tipo_cobro) {
          case "efectivo":
            _val = "EFECTIVO";
            break;
          case "tarjeta-debito":
            _val = "TARJETA DE DÉBITO";
            break;

          case "tarjeta-credito":
            _val = "TARJETA DE CRÉDITO";
            break;

          case "billetera-virtual":
            _val = "BILLETERA VIRTUAL";
            break;

          case "obra-social":
            _val = "OBRA SOCIAL";
            break;

          case "descuento-especial":
            _val = "DESCUENTO ESPECIAL";
            break;

          case "otro":
            _val = "OTRO";
            break;

          case "transferencia-bancaria":
            _val = "TRANSFERENCIA BANCARIA";
            break;

          case "cheque":
            _val = "CHEQUE";
            break;
        }
        return _val;
      },
    },
    {
      field: "importe_cobrado",
      headerName: "Total cobrado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe_cobrado;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "importe_recargo",
      headerName: "Recargo aplicado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe_recargo;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "importe_descuento",
      headerName: "Descuento aplicado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe_descuento;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "detalle_mdc",
      headerName: "Detalle del medio de cobro",
      headerAlign: "center",
      align: "left",
      flex: 4,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = "";
        switch (params.row.tipo_cobro) {
          case "efectivo":
            _val = "";
            break;
          case "tarjeta-debito":
            _val =
              params.row.marca_tarjeta +
              " " +
              params.row.banco_entidad_tarjeta_banco +
              " - CUPON: " +
              params.row.numero_cupon +
              " - LOTE: " +
              params.row.numero_lote +
              " - DESCUENTO: " +
              params.row.porcentaje_descuento +
              "%";
            break;

          case "tarjeta-credito":
            _val =
              params.row.marca_tarjeta +
              " " +
              params.row.banco_entidad_tarjeta_banco +
              " - CUOTAS: " +
              params.row.cantidad_cuotas +
              " - CUPON: " +
              params.row.numero_cupon +
              " - LOTE: " +
              params.row.numero_lote +
              " - DESCUENTO: " +
              params.row.porcentaje_descuento +
              "%" +
              " - INTERES: " +
              params.row.porcentaje_interes +
              "%";
            break;

          case "billetera-virtual":
            _val = params.row.descripcion_billetera;
            break;

          case "obra-social":
            _val =
              params.row.descripcion_obra_social +
              " - " +
              params.row.descripcion_obra_social_plan +
              " - BENEFICIARIO: " +
              params.row.apellido_cliente +
              " " +
              params.row.nombre_cliente +
              " - NUMERO: " +
              params.row.numero_beneficiario +
              " - AUTORIZACION: " +
              params.row.numero_autorizacion;
            break;

          case "descuento-especial":
            _val = params.row.descripcion;
            break;

          case "otro":
            _val = params.row.descripcion;
            break;

          case "transferencia-bancaria":
            _val =
              params.row.banco_cuenta_bancaria +
              " - COMPROBANTE: " +
              params.row.numero_comprobante;
            break;

          case "cheque":
            _val =
              params.row.banco +
              " - NUMERO: " +
              params.row.numero +
              " - VENCIMIENTO: " +
              params.row.fecha_cobro;
            break;
        }
        return _val.toUpperCase();
      },
    },
  ];

  const tableEstadoColumns = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    // {
    //   field: "odoo_fecha_actualizacion",
    //   headerName: "Fecha ",
    //   headerAlign: "center",
    //   align: "right",
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params) => {
    //     let _val = params.row.odoo_fecha_actualizacion;
    //     _val = _val ? _val : "";
    //     return _val;
    //   },
    // },
    {
      field: "username",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_usuario + " " + params.row.apellido_usuario;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  // ################################################################################
  // cuando se carga el componente
  //
  useEffect(() => {
    const load = async () => {
      setIsDoingSomething(true);
      const response = await getCobranza(idCobranza);
      setIsDoingSomething(false);

      if (response.ok) {
        let _cobranzaCabecera = response.data.data.cobranza;
        let _cobranzaEstado = response.data.data.cobranza_estado;
        let _ultimoEstado = _cobranzaEstado.find((item) => item.ultimo_estado === true).estado;
        _cobranzaCabecera.ultimoEstado = _ultimoEstado.toUpperCase();
        let _cobranzaGC = response.data.data.cobranza_gc;
        let _cobranzaMDC = response.data.data.cobranza_mdc;

        setCobranzaCabecera(_cobranzaCabecera);
        setCobranzaEstado(_cobranzaEstado);
        setCobranzaGC(_cobranzaGC);
        setCobranzaMDC(_cobranzaMDC);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    load();
  }, []);
  //
  // ################################################################################
  //
  const handleClose = () => {
    window.close();
  };
  //
  // ################################################################################
  //
  const verGestionComercial = (parRow) => {
    let _id = parRow.id_gc;
    const _url = `/gestion-atencion/${_id}/view`;
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          {!isEmptyObject(cobranzaCabecera) && (
            <>
              <Box sx={{ m: 1 }}>
                <Box sx={{ p: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Typography variant="h5" display="block" gutterBottom>
                        Cobranza {cobranzaCabecera.codigo}
                      </Typography>
                    </Grid>

                    <Item label="Fecha de registración" value={cobranzaCabecera.fecha_creacion} md={2} lg={2} xl={2} />
                    <Item label="Total cobrado" value={formatMoney(
                      cobranzaCabecera.importe_total_cobrado +
                      cobranzaCabecera.importe_total_recargo
                    )} md={2} lg={2} xl={2} valueAlign="right" valueColor="info.main" />
                    <Item label="Total descuento" value={formatMoney(cobranzaCabecera.importe_total_descuento)} md={2} lg={2} xl={2} valueAlign="right" valueColor="info.main" />
                    <Item label="Total recargo" value={formatMoney(cobranzaCabecera.importe_total_recargo)} md={2} lg={2} xl={2} valueAlign="right" valueColor="info.main" />
                    <Item label="Número de factura" value={cobranzaCabecera.numero_factura || ""} md={2} lg={2} xl={2} />
                    <Item label="Estado del comprobante" value={cobranzaCabecera.ultimoEstado} md={2} lg={2} xl={2} />
                  </Grid>
                </Box>

                {/* gestion comercial cobrada */}

                <Box sx={{ m: 1, mb: 2, p: 1 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Gestión Comercial Cobrada
                  </Typography>
                  <DataGrid
                    rows={cobranzaGC}
                    columns={tableGCColumns}
                    {...tableOptions}
                  />
                </Box>

                {/* medios de cobro */}

                <Box sx={{ m: 1, mb: 2, p: 1 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Medios de Cobro
                  </Typography>
                  <DataGrid
                    rows={cobranzaMDC}
                    columns={tableMDCColumns}
                    {...tableOptions}
                  />
                </Box>

                {/* estados */}

                <Box sx={{ mx: 1, px: 1, pb: 1 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Estados
                  </Typography>
                  <DataGrid
                    rows={cobranzaEstado}
                    columns={tableEstadoColumns}
                    {...tableOptions}
                  />
                </Box>
              </Box>
              <Box sx={{ textAlign: "right", p: 1 }}>
                <Button sx={{ mr: 1 }} variant="outlined" onClick={handleClose}>
                  Cerrar
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Paper>

      {/* >>>> Messages */}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};

export default CobranzaVer;
